module.exports = __webpack_public_path__ + "static/media/doctors.bf7e4dfd.png";